import { _defineProperty } from "@slyte/core/src/lyte-utils";
import { Route } from "../../../node_modules/@slyte/router/index.js";
let ModalComp;

class Modal extends Route {
  render() {
    return { outlet: '#zcatcomponent', component: ModalComp };
  }

  static actions(arg1) {
    return Object.assign(super.actions({}), arg1);
  }

  _() {
    _;
  }

  getRequirements() {
    arguments[1].push(
      import(/* webpackChunkName: "components/javascript/zcat-components/modal-comp" */
      "../../../components/javascript/zcat-components/modal-comp").then(function(res) {
        ModalComp = res.ModalComp;
      })
    );

    
;
  }
}

export { Modal };
